import './LoadingSpinner.css';

export default function LoadingSpinner() {
    return (
        <div className="loading-spinner-overlay">
            <div className="loading-spinner" />
        </div>
    );
}
